import 'uni-pages';import 'uni-h5';import Vue from 'vue'
import App from './App'
import api from './api'
import util from './common/util'
import store from './store'

Vue.config.productionTip = false

App.mpType = 'app'
import request from '@/common/request'
import GUtil from '@/common/GUtil'
import math from '@/common/math'
Vue.prototype.$gUtil = GUtil
Vue.prototype.$math = math
Vue.prototype.$r = request
Vue.prototype.$store = store
Vue.prototype.$api = api
Vue.prototype.$util = util

// main.js
import uView from '@/uni_modules/uview-ui'
Vue.use(uView)


const app = new Vue({
	store,
    ...App
})
app.$mount()